'use strict';
import React, { useEffect, useCallback, useMemo } from 'react';
import Moment from 'moment';
import { Button } from '@src/components/ui/button/button';
import PropTypes from 'prop-types';
import 'daterangepicker';

export const SearchComponent = ({ keyword, searchGooglePlaces }) => {
    const dateFormat = useMemo(() => process.env.DATE_FORMAT, []);
    const searchType = useMemo(() => process.env.SEARCH_TYPE, []);
    const searchEnableDate = useMemo(() => process.env.SEARCH_ENABLE_DATE === 'true', []);

    // legacy jQuery setup
    useEffect(() => {
        if (typeof document === 'undefined' || typeof window === 'undefined') {
            return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        let startTimestamp = '';
        let endTimestamp = '';
        let dateRange = '';
        let isAllDates = false;

        if (urlParams.has('location')) {
            $('.h-spacetime-search-location input').val(decodeURIComponent(urlParams.get('location')));
        }

        if (urlParams.has('isAllDates')) {
            isAllDates = urlParams.get('isAllDates').toLowerCase() === 'true';
        }

        if (!isAllDates) {
            if (urlParams.has('startTimestamp')) {
                startTimestamp = urlParams.get('startTimestamp');
            }
            if (urlParams.has('endTimestamp')) {
                endTimestamp = urlParams.get('endTimestamp');
            }

            if (startTimestamp && endTimestamp) {
                startTimestamp = Moment(startTimestamp, 'X', true);
                endTimestamp = Moment(endTimestamp, 'X', true);

                if (startTimestamp.isValid() && endTimestamp.isValid()) {
                    startTimestamp = startTimestamp.utc().format(dateFormat);
                    endTimestamp = endTimestamp.utc().format(dateFormat);

                    dateRange = `${startTimestamp} - ${endTimestamp}`;
                } else {
                    startTimestamp = '';
                    endTimestamp = '';
                }
            }
        } else {
            dateRange = 'All Dates';
        }

        $('.h-spacetime-search-date .rangepicker').daterangepicker({
            autoUpdateInput: false,
            locale: {
                format: dateFormat,
                cancelLabel: 'Clear',
                applyLabel: 'Apply'
            }
        });

        $('.h-spacetime-search-date .rangepicker').on('apply.daterangepicker', (event, picker) => {
            if ($('.input-alldates').is(':checked')) {
                $(event.target).val('All Dates');
            } else {
                $(event.target).val(`${picker.startDate.format(dateFormat)} - ${picker.endDate.format(dateFormat)}`);
            }
        });

        $('.h-spacetime-search-date .rangepicker').on('cancel.daterangepicker', event => {
            $(event.target).val('');
        });

        $(document).on('change', '.input-alldates', function() {
            if ($(this).is(':checked')) {
                $('.calendar-table').addClass('ol_disabled');
            } else {
                $('.calendar-table').removeClass('ol_disabled');
            }
        });

        if ($('.daterangepicker .drp-calendar.right').length > 0) {
            $('.calendar-table').before(
                `<div class="block-alldates">
                    <span class="block-check"><input ${
                        isAllDates ? 'checked' : ''
                    } type="checkbox" class="input-alldates"></span>
                    <span class="block-check-txt">All Dates</span>
                </div>`
            );
            $('.daterangepicker .drp-calendar.right').hide();
            $('.daterangepicker .drp-calendar.left').prepend(
                '<div class="custom-top-45 custom-daterangepicker-append next available"><span></span></div>'
            );
        }

        if (searchType !== 'keyword' && searchGooglePlaces) {
            $('.h-spacetime-search-location input').autocomplete({
                source: (req, res) => {
                    const keyword = $('.h-spacetime-search-location input').val();

                    if (keyword) {
                        searchGooglePlaces(keyword, places => {
                            res(places);
                        });
                    } else {
                        res([]);
                    }
                }
            });
        }

        if (startTimestamp && endTimestamp) {
            const dr = $('.h-spacetime-search-date .rangepicker').data('daterangepicker');
            dr.setStartDate(startTimestamp);
            dr.setEndDate(endTimestamp);
        }

        $('.h-spacetime-search-date .rangepicker').val(dateRange);

        if (isAllDates) {
            $('.calendar-table').addClass('ol_disabled');
        }

        if (urlParams.has('serviceableArea') && urlParams.get('serviceableArea')) {
            $('.h-spacetime-search-location input').val(urlParams.get('serviceableArea'));
        }
    }, [dateFormat, searchType, searchEnableDate, searchGooglePlaces]);

    const gotoSearch = useCallback(
        e => {
            const keyword = $('.h-spacetime-search-looking input').val();
            const location = $('.h-spacetime-search-location input').val();
            const range = $('.h-spacetime-search-date .rangepicker').val();
            $('.h-spacetime-search-date .rangepicker').removeClass('error-con');

            let startTimestamp = '';
            let endTimestamp = '';
            const isAllDates = range.toLowerCase() === 'all dates';

            if (range && !isAllDates) {
                const array = range.split('-');

                if (array.length < 2) {
                    $('.h-spacetime-search-date .rangepicker').addClass('error-con');
                    return;
                }

                const startDate = Moment(array[0].trim(), dateFormat, true);
                const endDate = Moment(array[1].trim(), dateFormat, true);

                if (!startDate.isValid() || !endDate.isValid() || startDate > endDate) {
                    $('.h-spacetime-search-date .rangepicker').addClass('error-con');
                    return;
                }

                startTimestamp = startDate.add(startDate.utcOffset(), 'm').format('X');
                endTimestamp = endDate
                    .add(endDate.utcOffset(), 'm')
                    .add(1439, 'm')
                    .format('X');
            }

            let params = [];
            if (searchType && searchType !== 'location') {
                params.push('keywords=' + encodeURIComponent(keyword));
            }
            if (searchType && searchType !== 'keyword') {
                params.push('serviceableArea=' + encodeURIComponent(location));
            }
            if (searchEnableDate) {
                params.push('startTimestamp=' + startTimestamp);
                params.push('endTimestamp=' + endTimestamp);
                params.push('isAllDates=' + isAllDates);
            }

            if (sessionStorage.getItem('userLatitude') && sessionStorage.getItem('userLongitude')) {
                params.push('userLatitude=' + sessionStorage.getItem('userLatitude'));
                params.push('userLongitude=' + sessionStorage.getItem('userLongitude'));
            }

            window.location.href = '/search?' + params.join('&');
        },
        [dateFormat, searchEnableDate, searchType]
    );

    const onKeyDown = useCallback(
        e => {
            if (e.keyCode === 13) {
                gotoSearch(e);
            }
        },
        [gotoSearch]
    );

    return (
        <div className='h-spacetime-search-bar'>
            {searchType && searchType !== 'location' && (
                <div className='h-spacetime-search-looking'>
                    <input
                        type='text'
                        className='!tw-py-[5px]'
                        placeholder='What task do you need help with?'
                        defaultValue={keyword}
                        autoComplete='off'
                        onKeyDown={onKeyDown}
                    />
                </div>
            )}

            {searchType && searchType !== 'keyword' && (
                <div className='h-spacetime-search-location'>
                    <i className='fas fa-map-marker-alt' />
                    <input
                        type='text'
                        className='!tw-py-[5px]'
                        placeholder='Location'
                        defaultValue=''
                        autoComplete='off'
                        onKeyDown={onKeyDown}
                    />
                </div>
            )}

            {searchEnableDate && (
                <div className='h-spacetime-search-date' style={{ display: 'none' }}>
                    <i className='fas fa-calendar' />
                    <input
                        type='text'
                        placeholder='Date'
                        className='rangepicker'
                        autoComplete='off'
                        onKeyDown={onKeyDown}
                    />
                </div>
            )}

            <div>
                <Button variant='outlined' onClick={gotoSearch} className='tw-border-none tw-text-[18px] h-100'>
                    <i className='fas fa-search' />
                </Button>
            </div>
        </div>
    );
};

SearchComponent.propTypes = {
    keyword: PropTypes.string,
    searchGooglePlaces: PropTypes.func
};
